import React from "react";
import LinearGoldText from "./linear-gold-text.tsx";

const GamingLicenseImg = require("../images/gaming-license.png");
export default function GamingLicense({ isMobile }) {
  return (
    <div style={{ width: "100%" }}>
      <LinearGoldText isMobile={isMobile} style={{ marginBottom: "15px" }}>
        Gaming License
      </LinearGoldText>
      <img
        src={GamingLicenseImg}
        height={isMobile ? "50px" : "80px"}
        alt="GamingLicense"
      />
    </div>
  );
}
